import React from "react";

const AlignCenter = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M21 9V15C21 15.3978 20.842 15.7794 20.5607 16.0607C20.2794 16.342 19.8978 16.5 19.5 16.5H12.75V19.5C12.75 19.6989 12.671 19.8897 12.5303 20.0303C12.3897 20.171 12.1989 20.25 12 20.25C11.8011 20.25 11.6103 20.171 11.4697 20.0303C11.329 19.8897 11.25 19.6989 11.25 19.5V16.5H4.5C4.10218 16.5 3.72064 16.342 3.43934 16.0607C3.15804 15.7794 3 15.3978 3 15V9C3 8.60218 3.15804 8.22064 3.43934 7.93934C3.72064 7.65804 4.10218 7.5 4.5 7.5H11.25V4.5C11.25 4.30109 11.329 4.11032 11.4697 3.96967C11.6103 3.82902 11.8011 3.75 12 3.75C12.1989 3.75 12.3897 3.82902 12.5303 3.96967C12.671 4.11032 12.75 4.30109 12.75 4.5V7.5H19.5C19.8978 7.5 20.2794 7.65804 20.5607 7.93934C20.842 8.22064 21 8.60218 21 9Z"
      fill="currentColor"
    />
  </svg>
);

export default AlignCenter;
